import { ApplicationVersion } from 'models/application-version.model';
import { createContext } from 'react';

export interface VersionContextType {
  version: ApplicationVersion;
  createOrUpdate: (
    version: ApplicationVersion,
    callback?: VoidFunction,
  ) => void;
}

export const VersionContext = createContext<VersionContextType>({
  version: undefined,
  createOrUpdate: (version: ApplicationVersion, callback?: VoidFunction) => {},
});
